import { Plan } from '@/domain/models/plan-license/plan-model'
import theme from '@/presentation/assets/styles/theme'
import CancelIcon from '@mui/icons-material/Cancel'
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined'
import { Chip, ChipProps } from '@mui/material'

type PlanChipProps = {
  plan: Plan.Enum | undefined
  customLabel?: string
  onDelete?: () => void
  size?: ChipProps['size']
  sx?: ChipProps['sx']
}

const PlanChip: React.FC<PlanChipProps> = ({ plan, customLabel, onDelete, size = 'small', sx }) => {
  if (!plan) {
    return null
  }

  const label = customLabel || plan.name

  return (
    <Chip
      icon={<WorkspacePremiumOutlinedIcon color="inherit" />}
      sx={{
        width: 'max-content',
        color: `var(--${plan.color})`,
        backgroundColor: `var(--${plan.backgroundColor})`,
        fontSize: theme.spacing(1.5),
        height: 24,
        gap: 1,
        padding: '0 8px',
        '& .MuiChip-icon': { margin: 0 },
        '& .MuiChip-label': { padding: 0 },
        ...sx
      }}
      label={label}
      size={size}
      onDelete={onDelete}
      deleteIcon={onDelete ? <CancelIcon /> : undefined}
    />
  )
}

export default PlanChip
